/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var workerCode = __webpack_require__(2);
	
	var calculateFibonacci = function calculateFibonacci(num) {
		return new Promise(function (resolve, reject) {
			var worker = new workerCode();
			worker.onerror = function (e) {
				worker.terminate();
				reject(e);
			};
			worker.onmessage = function (e) {
				worker.terminate();
				resolve(e.data);
			};
			worker.postMessage(num);
		});
	};
	window.calc = function () {
		var _loop = function _loop(i) {
			var e = document.getElementById("result" + i);
			e.value = "Calculating...";
			calculateFibonacci(40 + i).then(function (res) {
				e.value = res;
			});
		};
	
		for (var i = 1; i <= 4; i++) {
			_loop(i);
		}
	};

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
		return new Worker(__webpack_require__.p + "8326e76ae84e026da11a.worker.js");
	};

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** app-bundle.js
 **/